'use strict';

const $ = window.jQuery;

function accordion() {
    const $title  = $('.faq-accordion__button')
    const $panel  = $('.faq-accordion__content')
    let id        = (window.location.href.indexOf("#") !== -1) ? window.location.href.substring(window.location.href.indexOf("#")) : false


    // Scroll to the question in URL
    if ( id ) {
        $('html, body').animate({
            scrollTop: $(id).offset().top - ($('#header').innerHeight() + 40)
        }, 500);

        let title  = $(id).find('.faq-accordion__title')
        let button = $(id).find('.faq-accordion__button')

        // Open the accordeon
        const $sibling = title.siblings('.faq-accordion__content')

        // Accordion
        button.addClass('is-active')
        button.attr('aria-expanded', 'true')
        $sibling.slideDown()

    }

    $title.on('click', function() {
        const $sibling = $(this).parent().siblings('.faq-accordion__content')

        // Accordion
        $(this).toggleClass('is-active')
        $(this).attr('aria-expanded', (i, attr) => 'true' === attr ? 'false' : 'true')
        $sibling.slideToggle()

        $title.not(this).removeClass('is-active').attr('aria-expanded', 'false')
        $panel.not($sibling).slideUp()
    })
}

module.exports = function () {
    if ( $('.faq-accordion').length <= 0 ) {
        return
    }

    $(document).on('facetwp-refresh, facetwp-loaded', function() {
        accordion()
    })
}
